<template>
  <n-modal v-bind="$props">
    <Form ref="modalForm" :model="model" :label-width="labelWidth" @submit.native.prevent>
      <!-- prettier-ignore -->
      <n-row-col2>
        <!-- companyId -->
        <n-field-selection v-model="model.companyId" field-name="companyId" selection-name="company.company" :error="error.companyId" label="company" :disabled="isEdit || disabled" />
        <!-- name -->
        <n-field-text v-model="model.name" field-name="name" label="name" :error="error.name" :disabled="disabled" />
      </n-row-col2>
      <n-row-col2>
        <!-- lpType -->
        <n-field-enum v-model="model.lpType" field-name="lpType" enum-name="LandingPageType" :error="error.lpType" label="lpType" :disabled="isEdit || disabled" />
        <!-- status -->
        <n-field-enum v-model="model.status" field-name="status" enum-name="CampaignStatus" :error="error.status" label="status" :disabled="disabled" />
      </n-row-col2>
      <n-row-col2>
        <!-- version -->
        <n-field-id v-model="model.version" label="version" disabled />
        <!-- pushSpecialOffer -->
        <n-field-boolean v-model="model.pushSpecialOffer" label="pushSpecialOffer" :error="error.pushSpecialOffer" :disabled="disabled" />
      </n-row-col2>
      <n-row-col2>
        <!-- priority -->
        <n-field-enum v-model="model.priority" field-name="priority" enum-name="CustomerOfferPriority" :error="error.priority" label="priority" :disabled="disabled" />
        <!-- abTesting -->
        <n-field-boolean v-model="model.abTesting" label="abTesting" :error="error.abTesting" :disabled="disabled" />
      </n-row-col2>
      <n-row-col2>
        <!-- variantPrefer -->
        <n-field-enum v-model="model.variantPrefer" field-name="variantPrefer" enum-name="LandingPageVariant" :error="error.variantPrefer" label="variantPrefer" :disabled="disabled" />
        <!-- variantARatio -->
        <n-field-percent v-model="model.variantARatio" format="0 %" field-name="variantARatio" :error="error.variantARatio" label="variantARatio" :disabled="disabled" />
      </n-row-col2>
      <n-row-col2>
        <!-- availableAfter -->
        <n-field-number v-model="model.availableAfter" field-name="availableAfter" :error="error.availableAfter" label="availableAfter" :disabled="disabled" suffix-text="ms" />
        <!-- availableDuration -->
        <n-field-number v-model="model.availableDuration" field-name="availableDuration" :error="error.availableDuration" label="availableDuration" :disabled="disabled" suffix-text="ms" />
      </n-row-col2>
      <n-row-col2>
        <!-- triggerOfferEnabled -->
        <n-field-boolean v-model="model.triggerOfferEnabled" label="triggerOfferEnabled" :error="error.triggerOfferEnabled" :disabled="disabled" />
        <!-- triggerOfferInterval -->
        <n-field-number v-model="model.triggerOfferInterval" field-name="triggerOfferInterval" :error="error.triggerOfferInterval" label="triggerOfferInterval" :disabled="!model.triggerOfferEnabled" suffix-text="ms" />
      </n-row-col2>
    </Form>
  </n-modal>
</template>

<script>
import NModal from '@/components/common/NModal';
import { validate, edit, add } from '@/api/company/company-campaign';

export default NModal.extend({
  name: 'ModalCompanyCampaign',
  components: { NModal },

  methods: {
    doSubmit(model) {
      return this.isEdit ? edit(model) : add(model);
    },

    doValidate(model) {
      return validate(model);
    },
  },

  data() {
    return {
      variantARatioScale: 2,
    };
  },
});
</script>
